<template></template>

<script lang="ts">
import { defineComponent, onMounted, computed, watch, ref, onUnmounted } from "vue";
import { useAIChat } from "~/composables/useAIChat";

export default defineComponent({
	name: "ChatlabWidget",
	props: {
		marginBottom: { type: String, default: "150px" },
		profile: { type: String, default: "default" },
	},
	setup(props) {
		const user = computed(() => useAuth.getUser());
		const { initChat, updateUserContext, destroyChat } = useAIChat(props.profile);
		const cmpOffset = ref(0);
		let cmpObserver: MutationObserver | null = null;

		const detectCmpOffset = () => {
			const cmpElement = document.getElementById("cookiescript_injected");
			cmpOffset.value = cmpElement ? cmpElement.getBoundingClientRect().height : 0;
		};

		useHead({
			style: [
				{
					innerHTML: computed(() => {
						const stickyOffset = parseInt(props.marginBottom) || 0;
						const total = Math.max(stickyOffset, cmpOffset.value);
						return `
						@media (max-width: 739px) {
                            .rcw-widget-container button.rcw-launcher { 
                                margin-bottom: ${total}px !important; 
                            }
                        }
					`;
					}),
				},
			],
		});

		onMounted(() => {
			initChat(user);

			detectCmpOffset();
			cmpObserver = new MutationObserver(detectCmpOffset);
			cmpObserver.observe(document.body, { childList: true });
		});

		onUnmounted(() => {
			cmpObserver?.disconnect();
			destroyChat();
		});

		watch(
			user,
			(newUser) => {
				if (newUser) {
					updateUserContext(newUser);
				}
			},
			{ deep: true, immediate: false }
		);

		return {};
	},
});
</script>
